<template>
    <div>

    	<!-- page header -->
        <page-heading show="true" pageTitle="HEADER-CATALOG-HISTORY"></page-heading>

        <!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

        <div class="columns" v-if="!isLoading">

    		<div class="col-main">

                <v-client-table class="tblVariantHistory" name="tbl-variantHistory" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions">

                    <template slot="updated" slot-scope="props">
                        <span v-html="formatDate(props.row.updated, true)" style="font-size: 11px; color: #444;"></span>
                    </template>

                    <!--
                    <template slot="event" slot-scope="props">
                        <template v-if="props.row.objectExtRef != ''">{{ props.row.objectExtRef }} - </template>
                        <lang :labelKey="getEventDescription(props.row)" :uppercase="false" :labelKey2="props.row.label"></lang>
                    </template>
                    -->

                    <template slot="changes" slot-scope="props">
                        <template v-if="props.row.changes.status && trimString(props.row.changes.status) != ''"><strong>Status:</strong>
                            <div v-html="props.row.changes.status"></div>
                        </template>
                        <template v-if="props.row.changes.deadline && trimString(props.row.changes.deadline) != ''"><br /><strong>Deadline:</strong>
                            <div v-html="props.row.changes.deadline"></div>
                        </template>
                        <template v-if="props.row.changes.assignee && trimString(props.row.changes.assignee) != ''"><br /><strong>Zugewiesen an:</strong>
                            <div v-html="props.row.changes.assignee" style="margin-bottom: 12px;"></div>
                        </template>
                        <template v-if="props.row.changes.kicker && trimString(props.row.changes.kicker) != ''"><br /><strong>Kicker:</strong><div v-html="props.row.changes.kicker" style="margin-bottom: 12px;"></div>
                        </template>
                        <template v-if="props.row.changes.headline && trimString(props.row.changes.headline) != ''"><br /><strong>Headline:</strong>
                        <div v-html="props.row.changes.headline"></div>
                        </template>
                        <template><br /><br /><strong>Content:</strong>
                            <div v-html="props.row.changes.content"></div>
                        </template>
                    </template>

                </v-client-table>


            </div>

        </div>
    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

	name: 'contentPoolVariantLogs',

	data() {

        return {
            isLoading: true,

            table: {
                tblData: [],
                tblColumns: ['updated', 'updaterName', 'action', 'changes'],
                tblOptions: {
                    trackBy: 'version',
                    perPage: 25,
                    orderBy: {
                        ascending: false,
                        column: 'version'
                    },
                    sortable: ['updated'],
                    filterByColumn: false,
                    filterable: false,

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        /*
                        version: function(h) {
                            return <lang labelKey="CP-VARIANT-HISTORY-TBL_HEADER-VERSION"></lang>
                        },
                        */

                        action: function(h) {
                            return <lang labelKey="CP-VARIANT-HISTORY-TBL_HEADER-ACTION"></lang>
                        },

                        changes: function(h) {
                            return <lang labelKey="CP-VARIANT-HISTORY-TBL_HEADER-CHANGES"></lang>
                        },

                        updaterName: function(h) {
                            return <lang labelKey="CP-VARIANT-HISTORY-TBL_HEADER-UPDATERNAME"></lang>
                        },

                        updated: function(h) {
                            return <lang labelKey="CP-VARIANT-HISTORY-TBL_HEADER-UPDATED"></lang>
                        },

                    },

                    sortIcon: {
                        base:'fa fa-sort',
                        up:'fa-sort-up',
                        down:'fa-sort-down'
                    },

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                }

            }
        }

    },

    created() {

        // console.log(this.$route.params);

        if(this.$route.params.contentVariantID) {
            this.fetchData(this.$route.params.contentVariantID);
        }

    },

    mounted() {


    },


    methods: {

        trimString(str) {

            if(typeof str == 'undefined')
                return '';

            return str.trim();

        },

        fetchData(variantId) {

            this.isLoading = true;
            var self = this;
            // variantId = 303;

            this.axios.get(this.$config.api + 'articleVariant/'+variantId+'/changeLog')
                .then((response) => {
                    // console.log("response: ", response.data);
                    self.table.tblData = response.data;
                    self.isLoading = false;
            })

        }
    }

}

</script>

<style scoped>

/*
.tblVariantHistory >>> th:first-child {
    width: 150px;
}
.tblVariantHistory >>> th:nth-child(2) {
    width: 120px;
}
.tblVariantHistory >>> th:nth-child(3) {
    width: 200px;
}
.tblVariantHistory >>> th:nth-child(4) {
    width: 120px;
}

.tblVariantHistory >>> td:nth-child(3) {
    white-space: pre-wrap;
    text-overflow: inherit;
    max-width: none;
}
.tblVariantHistory >>> td:last-child {
    white-space: pre-wrap;
    text-overflow: inherit;
    max-width: none;
}
.tblVariantHistory >>> td:last-child s {
    color: red;
}
.tblVariantHistory >>> td:last-child b {
    color: green;
}
*/

.tblVariantHistory >>> th:first-child {
    width: 120px;
}
.tblVariantHistory >>> th:nth-child(2) {
    width: 200px;
}
.tblVariantHistory >>> th:nth-child(3) {
    width: 120px;
}
.tblVariantHistory >>> td:nth-child(4) {
    white-space: pre-wrap;
    text-overflow: inherit;
    max-width: none;
}
.tblVariantHistory >>> td:last-child {
    white-space: pre-wrap;
    text-overflow: inherit;
    max-width: none;
}
.tblVariantHistory >>> td:last-child s {
    color: red;
}
.tblVariantHistory >>> td:last-child b {
    color: green;
}

</style>
